import { render } from "./SectionHeader.vue?vue&type=template&id=42f17205&scoped=true&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=42f17205&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f17205"]])

export default __exports__